<template>
  <div>
    <!--
    <div v-if="this.showCloseButton" class="close" @click="exit">
      <img src="../assets/close.png" />
    </div>
    -->

    <attract v-if="this.activeModule === 'Attract'"></attract>
    <intro v-if="this.activeModule === 'Intro'"></intro>
    <ReadyToPlay v-if="this.activeModule === 'ReadyToPlay'"></ReadyToPlay>
    <wifi-oops v-if="this.activeModule === 'WifiOips'"></wifi-oops>
    <countdown v-if="this.activeModule === 'Countdown'"></countdown>
    <game-on v-if="this.activeModule === 'GameOn'"></game-on>
    <sign-in v-if="this.activeModule === 'SignIn'"></sign-in>
    <questions v-if="this.activeModule === 'Questions'"></questions>
    <incorrect-end v-if="this.activeModule === 'IncorrectEnd'"></incorrect-end>
    <time-up-end v-if="this.activeModule === 'TimeUpEnd'"></time-up-end>
    <winner v-if="this.activeModule === 'Winner'"></winner>
    <winner-big v-if="this.activeModule === 'WinnerBig'"></winner-big>
    <scores v-if="this.activeModule === 'Scores'"></scores>
    <thanks-end v-if="this.activeModule === 'ThanksEnd'"></thanks-end>

    <img
      class="nissan_next_trivia_logo"
      :class="{ 'corp-logo': config.tierType === 'CORP' }"
      alt=""
      v-if="this.activeModule !== 'Questions'
        && this.activeModule !== 'WinnerBig'
        && this.activeModule !== 'SignIn'
      "
    >

  </div>
</template>

<script>
import io from 'socket.io-client';
import axios from 'axios';
import {
  mapGetters,
  mapMutations,
} from 'vuex';
import Attract from './Attract.vue';
import Intro from './Intro.vue';
import ReadyToPlay from './ReadyToPlay.vue';
import WifiOops from './WifiOops.vue';
import Countdown from './Countdown.vue';
import GameOn from './GameOn.vue';
import SignIn from './SignIn.vue';
import Questions from './Questions.vue';
import IncorrectEnd from './IncorrectEnd.vue';
import TimeUpEnd from './TimeUpEnd.vue';
import Winner from './Winner.vue';
import WinnerBig from './WinnerBig.vue';
import Scores from './Scores.vue';
import ThanksEnd from './ThanksEnd.vue';

let socket;

export default {
  name: 'Main',
  components: {
    Attract,
    Intro,
    ReadyToPlay,
    WifiOops,
    Countdown,
    SignIn,
    GameOn,
    Questions,
    IncorrectEnd,
    TimeUpEnd,
    Winner,
    WinnerBig,
    Scores,
    ThanksEnd,
  },
  data() {
    return {
      interval: null,
      questionInterval: null,
      majorWinnerId: -1,
    };
  },
  computed: {
    ...mapGetters([
      'config',
      'socket',
      'id',
      'isConnected',
      'userRegistered',
      'questions',
      'currentQuestionIndex',
      'correctAnswer',
      'selectedAnswer',
      'sessionIndex',
      'gameStarted',
      'userReady',
      'countdownInterval',
      'registerCountdownInterval',
      'showPage',
      'activeModule',
      'questionTimerComplete',
      'questionStartTime',
      'currentQuestionCount',
      'currentQuestion',
      'triggerDisconnect',
      'triggerConnect',
      'gameRoomId',
    ]),
    showCloseButton() {
      return (
        (this.activeModule === 'TimeUpEnd' && this.config.tierType === 'TIER2')
        || (this.activeModule === 'IncorrectEnd' && this.config.tierType === 'TIER2')
        || this.activeModule === 'WifiOops'
        || this.activeModule === 'Intro'
      );
    },
  },
  watch: {
    userReady(newData) {
      console.log(`User Ready: ${newData}`);
      if (newData) {
        console.log('User Ready: send id to server');

        socket.emit('userReady', {
          id: this.id,
        });
      }
    },
    selectedAnswer() {
      socket
        .emit('submitTime', {
          id: this.id,
          time: Date.now() - this.questionStartTime,
          isCorrect: this.selectedAnswer === this.correctAnswer,
        });
    },
    triggerDisconnect(newVal) {
      if (newVal) {
        this.disconnect();
        this.reset();
        this.goToAttract();
        this.setTriggerDisconnect({ value: false });
      }
    },
    triggerConnect(newVal) {
      if (newVal) {
        this.connect();
        this.setTriggerConnect({ value: false });
      }
    },
    gameRoomId(newVal) {
      console.log('gameRoomId: ', newVal);
      if (newVal && newVal !== -1) {
        // First, get the Tier Type from the server. Upon receiving the value, the registerMobile will be called.
        socket
          .emit('getEventType', {
            gameRoomId: newVal,
          });
      }
    },
  },
  mounted() {
    this.$store.commit('setTriggerConnect', { value: true });
    this.setUserRegistered({
      value: false,
    });
    this.$root.$on('requestNextQuestion', () => {
      this.requestNextQuestion();
    });
    this.$root.$on('requestShowAnswer', () => {
      this.requestShowAnswer();
    });
    this.$root.$on('requestShowScores', () => {
      this.requestShowScores();
    });
    this.$root.$on('requestStartTIER3', () => {
      this.requestStartTIER3();
    });
    this.$root.$on('requestExit', () => {
      this.disconnect();
      this.reset();
    });
  },
  methods: {
    ...mapMutations([
      'setSocket',
      'setId',
      'setIsConnected',
      'setUserRegistered',
      'setQuestions',
      'setCurrentQuestionIndex',
      'setCorrectAnswer',
      'setSelectedAnswer',
      'setSessionIndex',
      'setGameStarted',
      'setUserReady',
      'setCountdownInterval',
      'setRegisterCountdownInterval',
      'setShowPage',
      'setActiveModule',
      'setQuestionTimerComplete',
      'setQuestionStartTime',
      'setCurrentQuestionCount',
      'setCurrentQuestion',
      'setRemainingTimeInSeconds',
      'setRemainingQuestionTimeInSeconds',
      'setShowAnswer',
      'setTriggerDisconnect',
      'setTriggerConnect',
      'setTierType',
      'reset',
      'setInvalidGameRoomId',
      'setEventId',
      'setEventName',
    ]),
    /*
    setRegistrationAccepted(data) {
      console.log('setRegistrationAccepted', data);
      const id = this.id;

      if (String(id) !== String(data.id)) {
        return;
      }
      if (this.uuid !== data.uuid) {
        return;
      }
      if (data.accepted && String(data.id) === String(this.tier1UserId)) {
        this.setUserRegistered({
          value: true,
        });
        this.setActiveModule({
          value: 'GameOn',
        });
      }
    },
    */
    exit() {
      this.disconnect();
      this.reset();
      this.goToAttract();
    },
    deviceOrientationChanged() {},
    onSessionInactive(data) {
      console.log(`Session Inactive: ${JSON.stringify(data)}`);
      this.setActiveModule({
        value: 'Attract',
      });
    },
    onStartCountdown(data) {
      console.log(`Start Countdown: ${JSON.stringify(data)}`);
      this.setActiveModule({
        value: 'ReadyToPlay',
      });
      this.setSessionIndex({
        value: data.sessionIndex,
      });
    },
    onSessionActive(data) {
      console.log(`Session Active: ${JSON.stringify(data)}`);
      this.setActiveModule({
        value: 'ReadyToPlay',
      });
      this.setEventId({ value: data.eventId });
      this.getQuestionSets(data.eventId);

      console.log(`Event id: ${this.$store.state.eventId} - Event name: ${this.$store.state.eventName} - Tier type: ${this.$store.state.config.tierType}`);
    },
    onShowLongCountdown(data) {
      console.log(`Show Long Cowntdown: ${JSON.stringify(data)}`);
      this.setGameStarted({
        value: false,
      });
      this.setSessionIndex({
        value: data.sessionIndex,
      });
      this.setActiveModule({
        value: 'Countdown',
      });

      const countdownStart = Date.now();
      const countdownOffset = data.remainingTimeInSeconds * 1000;
      clearInterval(this.interval);
      let instanceInterval;
      this.interval = setInterval(() => {
        const secondsTotal = Math.round((countdownOffset - Math.round(Date.now() - countdownStart)) / 1000);
        this.setRemainingTimeInSeconds({ value: secondsTotal });
        if (secondsTotal < -1) {
          clearInterval(instanceInterval);
        }
      }, 250);
      instanceInterval = this.interval;
    },
    onShowRegistrationForm(data) {
      console.log(`Show Registration Form: ${JSON.stringify(data)}`);

      /*
      if (data.remainingTimeInSeconds < 0) {
        this.setActiveModule({
          value: 'TimeUpEnd',
        });
        return;
      }
      */

      const countdownStart = Date.now();
      const countdownOffset = data.remainingTimeInSeconds * 1000;
      clearInterval(this.interval);
      let instanceInterval;
      this.interval = setInterval(() => {
        const secondsTotal = Math.round((countdownOffset - Math.round(Date.now() - countdownStart)) / 1000);
        this.setRemainingTimeInSeconds({ value: secondsTotal });
        if (secondsTotal < -1) {
          clearInterval(instanceInterval);
        }
      }, 250);
      instanceInterval = this.interval;

      this.setCurrentQuestionIndex({
        value: -1,
      });
      this.setSessionIndex({
        value: data.sessionIndex,
      });
      if (this.userReady) {
        this.setActiveModule({
          value: 'SignIn',
        });
      } else {
        this.setActiveModule({
          value: 'ReadyToPlay',
        });
      }
      // START TIMER
    },
    onShowShortCountdown(data) {
      // TODO Maybe obsolete
      console.log(`Show Short Countdown: ${JSON.stringify(data)}`);
      this.setSessionIndex({
        value: data.sessionIndex,
      });
    },
    onEndCountdown(data) {
      console.log(`End Countdown: ${JSON.stringify(data)}`);
      this.setCurrentQuestionIndex({
        value: -1,
      });
      if (this.userRegistered && !this.gameStarted) {
        this.$keen.recordEvent('gameOn', {
          data,
        });
        this.setActiveModule({
          value: 'GameOn',
        });
      } else if (this.config.tierType === 'TIER1') {
        this.setActiveModule({
          value: 'Attract',
        });
      }
    },
    onShowNextQuestion(data) {
      console.log(`Show Next Question: ${JSON.stringify(data)}`);

      if (data.sessionIndex) {
        this.setSessionIndex({
          value: data.sessionIndex,
        });
      }

      this.setShowAnswer({ value: false });

      if (!this.userRegistered) {
        this.setActiveModule({
          value: 'TimeUpEnd',
        });
        this.setUserReady({
          value: false,
        });
        this.setUserRegistered({
          value: false,
        });
        this.setGameStarted({
          value: false,
        });
        // this.disconnect();
        this.reset();
        return;
      }

      this.$keen.recordEvent('showNextQuestion', {
        data,
      });

      const questionStartTime = Date.now();
      this.setGameStarted({
        value: true,
      });
      this.setSelectedAnswer({
        value: '',
      });
      this.setQuestionStartTime({
        value: questionStartTime,
      });
      this.setCurrentQuestionIndex({
        value: this.currentQuestionIndex + 1,
      });
      this.setCurrentQuestionCount({
        value: this.questions.children[this.sessionIndex].fields.quiz_repeater.length,
      });
      this.setCurrentQuestion({
        value: this.questions.children[this.sessionIndex].fields.quiz_repeater[this.currentQuestionIndex].fields,
      });
      this.setCorrectAnswer({
        value: this.currentQuestion.quiz_correct_answer,
      });
      this.setShowAnswer({
        value: false,
      });
      this.setActiveModule({
        value: 'Questions',
      });

      const countdownStart = Date.now();
      const countdownOffset = data.questionDurationInSeconds * 1000;
      clearInterval(this.questionInterval);
      let instanceQuestionInterval;
      this.setRemainingQuestionTimeInSeconds({ value: data.questionDurationInSeconds });
      this.questionInterval = setInterval(() => {
        const secondsTotal = Math.round((countdownOffset - Math.round(Date.now() - countdownStart)) / 1000);
        this.setRemainingQuestionTimeInSeconds({ value: secondsTotal });
        if (secondsTotal < -1) {
          clearInterval(instanceQuestionInterval);
        }
      }, 250);
      instanceQuestionInterval = this.questionInterval;
      this.setQuestionTimerComplete({ value: false });
    },
    onQuestionTimerComplete(data) {
      console.log(`Questions Timer Complete: ${JSON.stringify(data)}`);
      this.setQuestionTimerComplete({
        value: true,
      });
    },
    onShowAnswer(data) {
      console.log(`Show Answer: ${JSON.stringify(data)}`);
      this.setShowAnswer({ value: true });
      this.majorWinnerId = -1;
    },
    onShowWinners(data) {
      console.log(`Show Winners - data: ${JSON.stringify(data)}`);
      // console.log(`Show Winners - userRegistered: ${this.userRegistered}`);

      if (!this.userRegistered) {
        return;
      }
      console.log(`Show Winners - this.socketId: ${this.socketId}`);

      if (this.socketId === this.majorWinnerId) {
        return;
      }

      if (this.config.tierType === 'CORP') {
        this.setActiveModule({
          value: 'ThanksEnd',
        });

        this.setUserReady({
          value: false,
        });
        this.setUserRegistered({
          value: false,
        });
        this.setGameStarted({
          value: false,
        });

        return;
      }

      // FIX: JEROME - Show incorrect end for Tier 1 and 2 - Award Winner are not used anymore for those tiers
      // TODO: Determine if this code is still needed for Tier3
      if (data.ids.indexOf(this.socketId) > -1) {
        // No award winner for TSF, Tier 1 or Tier 2
        if (this.config.tierType === 'TSF'
          || this.config.tierType === 'TIER1'
          || this.config.tierType === 'TIER2'
        ) {
          this.setActiveModule({
            value: 'IncorrectEnd',
          });
        } else {
          this.setActiveModule({
            value: 'Winner',
          });
        }
      } else {
        this.setActiveModule({
          value: 'IncorrectEnd',
        });
      }

      this.setUserReady({
        value: false,
      });
      this.setUserRegistered({
        value: false,
      });
      this.setGameStarted({
        value: false,
      });
    },
    onShowScores(data) {
      console.log(`Show Scores - data: ${JSON.stringify(data)}`);

      const foundUser = data.scores.find(x => x.socketId === this.socketId);

      if (foundUser) {
        this.$store.commit('setSingleUserScore', { value: foundUser.score });
      }

      this.setActiveModule({
        value: 'Scores',
      });
      this.setUserReady({
        value: false,
      });
      this.setUserRegistered({
        value: false,
      });
      this.setGameStarted({
        value: false,
      });
    },
    onSetMajorWinner(data) {
      console.log(`Major Winner: ${JSON.stringify(data)}`);

      if (this.config.tierType === 'CORP') {
        this.setActiveModule({
          value: 'ThanksEnd',
        });
      } else {
        this.setActiveModule({
          value: 'WinnerBig',
        });
      }

      this.setUserReady({
        value: false,
      });
      this.setUserRegistered({
        value: false,
      });
      this.setGameStarted({
        value: false,
      });
    },
    onTimesUp(data) {
      console.log(`Times Up: ${JSON.stringify(data)}`);
      this.setActiveModule({
        value: 'TimeUpEnd',
      });
      this.setUserReady({
        value: false,
      });
      this.setUserRegistered({
        value: false,
      });
      this.setGameStarted({
        value: false,
      });
      this.disconnect();
      this.reset();
    },
    onNoWifi(data) {
      console.log(`No Wifi: ${JSON.stringify(data)}`);
      this.setActiveModule({
        value: 'WifiOops',
      });
    },
    onCancelGame(data) {
      console.log(`Cancel Game: ${JSON.stringify(data)}`);
      this.disconnect();
      this.reset();
      this.goToAttract();
    },
    onEndGame(data) {
      console.log(`End Game: ${JSON.stringify(data)}`);
      this.disconnect();
      this.reset();
      if (this.config.tierType === 'TIER1') {
        this.goToAttract();
      } else if (this.activeModule !== 'Winner' && this.activeModule !== 'WinnerBig') {
        this.goToAttract();
      }
    },
    getQuestionSets(eventId) {
      axios
        .get(`${this.$store.state.config.url}/trivia/event/${eventId}/questions`)
        .then((response) => {
          this.setQuestions({ value: response.data });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    connect() {
      if (this.isConnected) {
        console.warn('Socket already connected.');
        return;
      }
      socket = io(process.env.VUE_APP_SOCKET_HOST ? process.env.VUE_APP_SOCKET_HOST : '/', {
        forceNew: true,
        path: '/api/socket.io',
      });

      // this.getQuestionSets();

      const id = (Math.random() * 10000000).toString();
      this.setId({
        value: id,
      });

      socket.on('connect', () => {
        /*
        socket.emit('registerMobile', {
          id,
          gameRoomId:
        });
        this.setIsConnected({
          value: true,
        });
        */

        this.socketId = socket.id;
        console.log('socket connected', socket.id);
      });
      socket.on('disconnect', () => {
        this.setIsConnected({
          value: false,
        });
        this.setUserReady({
          value: false,
        });

        this.socketId = '';
        console.log('socket disconnected');
      });
      socket.on('sessionInactive', (data) => {
        this.onSessionInactive(data);
      });
      socket.on('startCountdown', (data) => {
        this.onStartCountdown(data);
      });
      socket.on('sessionActive', (data) => {
        this.onSessionActive(data);
      });
      socket.on('showLongCountdown', (data) => {
        this.onShowLongCountdown(data);
      });
      socket.on('showRegisterForm', (data) => {
        this.onShowRegistrationForm(data);
      });
      socket.on('showShortCountdown', (data) => {
        this.onShowShortCountdown(data);
      });
      socket.on('endCountdown', (data) => {
        this.onEndCountdown(data);
      });
      socket.on('showNextQuestion', (data) => {
        this.onShowNextQuestion(data);
      });
      socket.on('questionTimerComplete', (data) => {
        this.onQuestionTimerComplete(data);
      });
      socket.on('showAnswer', (data) => {
        this.onShowAnswer(data);
      });
      socket.on('showWinners', (data) => {
        this.onShowWinners(data);
      });
      socket.on('showScores', (data) => {
        this.onShowScores(data);
      });
      /*
      socket.on('showMajorWinner', (data) => {
        this.onShowMajorWinner(data);
      });
      */
      socket.on('setMajorWinner', (data) => {
        this.onSetMajorWinner(data);
      });
      socket.on('timesUp', (data) => {
        this.onTimesUp(data);
      });
      socket.on('noWifi', (data) => {
        this.onNoWifi(data);
      });
      socket.on('cancelGame', (data) => {
        this.onCancelGame(data);
      });
      socket.on('endGame', (data) => {
        this.onEndGame(data);
      });
      socket.on('setTierType', (data) => {
        const newTierType = data.tierType;
        if (newTierType.length > 0) {
          socket
            .emit('registerMobile', {
              id: this.id,
              gameRoomId: this.gameRoomId,
            });

          if (this.config.tierType === '') {
            this.setTierType(data);
          }
          this.setEventName(data.name);
        }
      });
      /*
      socket.on('setRegistrationAccepted', (data) => {
        this.setRegistrationAccepted(data);
      });
      */
      socket.on('invalidGameRoomId', () => {
        this.setInvalidGameRoomId({
          value: true,
        });
      });
      socket.on('tier3VersionReady', () => {
        socket
          .emit('getEventType', {
            gameRoomId: this.$store.state.gameRoomId,
          });
      });
    },
    goToAttract() {
      this.setActiveModule({
        value: 'Attract',
      });
      this.$store.commit('setTriggerConnect', { value: true });
    },
    disconnect() {
      this.setUserReady({
        value: false,
      });
      this.setUserRegistered({
        value: false,
      });
      this.setGameStarted({
        value: false,
      });
      socket.disconnect();
    },
    delayedDisconnect() {
      setTimeout(this.disconnect, 2000);
    },
    requestNextQuestion() {
      socket
        .emit('nextQuestionRequestedFromFrontEnd', {
          eventId: this.$store.state.eventId,
          socketId: this.socketId,
        });
    },
    requestShowAnswer() {
      socket
        .emit('showAnswerRequestedFromFrontEnd', {
          eventId: this.$store.state.eventId,
          socketId: this.socketId,
        });
    },
    requestShowScores() {
      socket
        .emit('showScoresRequestedFromFrontEnd', {
          eventId: this.$store.state.eventId,
          socketId: this.socketId,
        });
    },
    requestStartTIER3() {
      socket
        .emit('requestStartTIER3', {
          eventId: this.$store.state.gameRoomId,
        });
    },
  },
};
</script>


<style lang="scss">
  @import '../styles/_variables.scss';
  @import '../styles/_reset.scss';
  html,
  body {
    font-family: 'Nissan-Brand-Regular';
    color: #fff;
    font-size: 14px;
  }

  html,
  body {
    width: 100%;
    height: 100%;
    position: fixed;
    overflow: hidden;
  }

  .app {
    position: absolute;
    width: 100%;
    height: 100%;
    background: url('../assets/bg-2025.png') ;
    background-size: 100% 100%;

    .nissan_next_trivia_logo {
      display: block;
      margin: 6vh auto;
      width: 50vh;
      max-width: 50%;
      transform: translate(0px, 0px);
      content:url('../assets/logo-2027.svg');
    }
    .nissan_next_trivia_logo_small {
      margin: 20px auto;
      max-width: 40%;
    }
    @media only screen and (max-width: 320px) {
      .nissan_next_trivia_logo {
        display: block;
        margin: 30px auto;
        max-width: 50%;
      }
    }
    .logo {
      width: 78px;
      position: absolute;
      top: 0;
      left: 40px;
      img {
        width: 100%;
      }
    }
    .close {
      width: 40px;
      position: absolute;
      z-index: 999;
      top: 25px;
      right: 25px;
      img {
        width: 100%
      }
    }
    .bg-footer {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 240px;
      background: url('../assets/bg_footer.png');
      background-size: 100% 100%;
    }
  }

.corp {
  background: url('../assets/bg_empty_corp.png');
  background-size: 100% 100%;
}

.corp-logo {
  max-width: 50% !important;
  content:url('../assets/nissan_next_trivia_logo_corp.png') !important;
}

.tier3-logo {
  max-width: 65% !important;
  content:url('../assets/nissan_next_trivia_logo_tier3.png') !important;
}
</style>
